import React, { PureComponent } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

import Logo from './logo';
import PhonesDesk from './phonesdesk';
import HoursOperation from './hoursoperation';


class HeaderMobile extends PureComponent {
    state = {
        right: false,
    };

    toggleDrawer = (side, open) => () => {
        this.setState({
          [side]: open,
        });
    };

    menus = [
        {title: 'A EMPRESA', url: '/#about'},
        {title: 'PRODUTOS', url: '/#products'},
        {title: 'CONTAINERS', url: '/containers'},
        {title: 'RAD', url: '/rad'},
        {title: '4RF', url: '/4rf'},
        {title: 'QUALIDADE E GARANTIAS', url: process.env.PUBLIC_URL + `/assets/pdf/garantia-servicos.pdf`},
        {title: 'CASOS DE SUCESSO', url: '/#cases'},
        {title: 'CONTATO', url: '/#contact'}
    ];

    render() {
        return (
            <header className="header-mobile">
                <Logo/>
                <IconButton 
                    className="menu-button" 
                    color="inherit" 
                    aria-label="Open drawer"
                    onClick={this.toggleDrawer('right', true)}
                >
                    <MenuIcon fontSize="large" color="#fff" />
                </IconButton>
                <SwipeableDrawer
                    anchor="right"
                    className="menu-drawer"
                    open={this.state.right}
                    onClose={this.toggleDrawer('right', false)}
                    onOpen={this.toggleDrawer('right', true)}                    
                    >
                    <div
                        tabIndex={0}
                        role="button"
                        onClick={this.toggleDrawer('right', false)}
                        onKeyDown={this.toggleDrawer('right', false)}                        
                    >
                        <Logo/>
                        <h3>Menu</h3>
                        <ul className="menu-sidebar">{ this.menus.map((item,key) => {
                            return ( 
                                <li key={key} >
                                    <a href={item.url}>{item.title}</a>
                                </li>
                            )
                        })}                            
                        </ul>
                        <PhonesDesk/>
                        <HoursOperation/>
                    </div>
                </SwipeableDrawer>
            </header>
        )
    }
}

export default HeaderMobile;